/*
 *   File : consent.js
 *   Author URI : https://evoqins.com
 *   Description : Confirmation modal to accept T&C
 *   Integrations : null
 *   Version : v1.1
 */

import { useEffect, useState } from "react";
import style from '../../Styles/Components/announcement.module.scss';
import { GradientButton } from "../Cta";
import { Icon } from "../Icon";
import APIService from "../../Services/api-service";
import { toast } from "react-toastify";
import Store from "../../Store";

const AcceptConsent = (props) => {
    const [isAccepted, setIsAccepted] = useState(false);
    const [apiLoader, setApiLoader] = useState(false);

    useEffect(() => {
        var my_modal = document.getElementById("consent");
        my_modal.addEventListener("hidden.bs.modal", () => {
            props.close();
        });
    }, [props.close]);

    function _handleAcceptConsent() {
        setApiLoader(true);
        const url = "kyc/consent";
        const payload = {
            consent: isAccepted,
            customer_id: props.id
        }

        APIService(true, url, payload).then((response) => {
            toast.dismiss();

            if (response.status_code === 200) {
                document.getElementById("close-modal").dispatchEvent(new Event("click"));
                Store.dispatch({
                    type: 'GET_KYC_DATA',
                    payload: response.kyc_data
                });
                props.accept(props.id);
            } else {
                toast.dismiss();
                toast.error(response.message);
            }
            setApiLoader(false);
        });
    }

    return (
        <div className={`modal fade ${style.e_announcement_modal}`}
            id="consent"
            tabIndex="-1"
            aria-labelledby="consent"
            aria-hidden="true"
            data-bs-backdrop="static" >
            <div className={`modal-dialog position-relative modal-dialog-centered ${style.e_dialog}`}>
                <div className={`modal-content bg-body-color text-center d-flex align-items-center padding-32px-all ${style.e_content} `}>
                    <Icon icon="close"
                        size={24}
                        id="close-modal"
                        data-bs-dismiss="modal"
                        className={`position-absolute cursor-pointer e-modal-close-btn right-32 ${style.e_close}`} />


                    <div className="row">
                        <div className="col-12 ">
                            <h5 className="color-almost-black e-poppins-semi-bold e-font-18 text-center">
                                Terms & Conditions
                            </h5>
                            <p className="color-black e-poppins-regular e-font-16 mb-0 text-start mt-4">
                                Before you proceed to e-Sign, please take a moment to review and accept our <a href="https://mtwealth.mastertrust.co.in/terms" target="_blank" className="color-ocean-blue e-poppins-semi-bold">Terms & Conditions</a>. This ensures you understand the rules, responsibilities, and legal agreements related to this process.                            </p>
                        </div>
                        <div className={`d-flex align-items-center gap-1 mt-4`}>
                            <Icon icon={isAccepted === true ? "cart-selected" : 'cart-unselected'}
                                size={24}
                                className='cursor-pointer'
                                onClick={() => setIsAccepted(!isAccepted)} />
                            <span className="color-text-black e-poppins-medium e-font-16 line-height-16px">
                                I agree to the Terms & Conditions
                            </span>
                        </div>
                        <div className="margin-32px-top d-sm-flex d-block justify-content-center gap-8px ">

                            <GradientButton label="Continue"
                                disabled={isAccepted === false || apiLoader}
                                onPress={_handleAcceptConsent}
                                loading={apiLoader}
                                className="e-font-16 padding-70px-lr padding-12px-tb w-mobile-100 mt-sm-0 mt-3" />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default AcceptConsent